// extracted by mini-css-extract-plugin
export default {"container":"AccountMenu__container-xYNkU","account":"AccountMenu__account-wJm_a"};